import { useIntl } from '@jetshop/intl'
import { DIGIFI_SORT_VALUES } from '../../DigifiSearch/constants'

export const useSortOptions = () => {
   const t = useIntl()
   return [
      { label: t('Most popular'), value: DIGIFI_SORT_VALUES.RELEVANCE },
      { label: t('Price-low-to-high'), value: DIGIFI_SORT_VALUES.PRICE_ASC },
      { label: t('Price-high-to-low'), value: DIGIFI_SORT_VALUES.PRICE_DESC },
      { label: t('Newest'), value: DIGIFI_SORT_VALUES.NEWEST },
      { label: t('Biggest discount'), value: DIGIFI_SORT_VALUES.DISCOUNT_DESC },
   ]
}
